import React, { useState } from "react";

import { Link } from "react-router-dom";

import {
  Menu,
  X,
} from "lucide-react";

import "./Header.css";

const Header = () => {

  const [mobileMenu, setMobileMenu] =
    useState(false);

  return (
    <header className="modern-header">

      <div className="modern-header-inner">

        {/* LOGO */}
        <Link
          to="/"
          className="modern-logo-wrapper"
        >

          <div className="modern-logo-text">
            RCS TOPUP & BILLING ENTITY
          </div>

        </Link>

        {/* DESKTOP NAV */}
        <nav className="modern-nav-links">

          <Link to="/">Home</Link>

          <Link to="/services">
            Services
          </Link>

          <Link to="/new">
            New
          </Link>

          <Link to="/about">
            About
          </Link>

          <Link to="/contact">
            Contact
          </Link>

        </nav>

{/* CTA BUTTON */}
<div className="modern-header-actions">

  <Link
    to="/services"
    className="modern-header-btn"
  >
    Get Started
  </Link>

</div>

        {/* MOBILE MENU BUTTON */}
        <button
          className="modern-mobile-toggle"
          onClick={() =>
            setMobileMenu(!mobileMenu)
          }
        >

          {mobileMenu ? (
            <X size={28} />
          ) : (
            <Menu size={28} />
          )}

        </button>

      </div>

      {/* MOBILE NAV */}
      <div
        className={`modern-mobile-menu ${
          mobileMenu
            ? "mobile-menu-open"
            : ""
        }`}
      >

        <Link
          to="/"
          onClick={() =>
            setMobileMenu(false)
          }
        >
          Home
        </Link>

        <Link
          to="/services"
          onClick={() =>
            setMobileMenu(false)
          }
        >
          Services
        </Link>

        <Link
          to="/new"
          onClick={() =>
            setMobileMenu(false)
          }
        >
          New
        </Link>

        <Link
          to="/about"
          onClick={() =>
            setMobileMenu(false)
          }
        >
          About
        </Link>

        <Link
          to="/contact"
          onClick={() =>
            setMobileMenu(false)
          }
        >
          Contact
        </Link>

      </div>

    </header>
  );
};

export default Header;